// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switch-session-curtain[data-v-4b357370]{display:grid;align-items:center;justify-items:center;place-items:center;position:absolute;width:100vw;height:100vh;z-index:1000;background-color:#004581;color:#fff;font:400 1.2rem/1.3em Open Sans,BlinkMacSystemFont,-apple-system,sans-serif;font-style:italic}", ""]);
// Exports
module.exports = exports;
